<template>
  <div class="text-center">
    <v-dialog
      contentClass="story-city-dialog"
      v-model="localShow"
      persistent
      max-width="614"
    >
      <v-card>
        <div class="d-flex pa-5 pb-2">
          <v-btn
            class="ml-auto"
            small
            icon
            @click="cancel"
          >
            <v-icon>$close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="text-center px-15 pb-10">
          <v-icon
            class="mb-4"
            color="error"
            size="52"
          >
            {{ icon ? icon : "$trash" }}
          </v-icon>
          <h2 class="mb-4">{{ $t(type + ".deleteModal.title") }}</h2>
          <div v-html="$t(type + '.deleteModal.info')" />
          <slot />
        </v-card-text>
        <v-card-actions class="d-flex align-center justify-center pb-12">
          <StoryCitySolidButton
            class="mr-2"
            color="backgroundExtraLight"
            x-large
            @click="cancel"
          >
            <span class="text--primaryText">
              {{ $t("forms.cancel") }}
            </span>
          </StoryCitySolidButton>
          <StoryCitySolidButton
            class="ml-2"
            color="error"
            x-large
            @click="confirm"
          >
            {{ $t(type + ".deleteModal.confirmButton") }}
          </StoryCitySolidButton>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StoryCitySolidButton from "@/components/Buttons/StoryCitySolidButton";

export default {
  components: {
    StoryCitySolidButton,
  },
  props: {
    deleteGuardNamespace: String,
    icon: String,
  },
  data() {
    return {
      localShow: false,
    };
  },
  methods: {
    cancel() {
      return this.$store.dispatch(`${this.deleteGuardNamespace}/cancel`);
    },
    confirm() {
      return this.$store.dispatch(`${this.deleteGuardNamespace}/confirm`);
    },
  },
  watch: {
    show(newValue) {
      this.localShow = newValue;
    },
    localShow(newValue) {
      if (!newValue && newValue != this.show) {
        return this.$store.dispatch(`${this.deleteGuardNamespace}/cancel`);
      }
    },
  },
  computed: {
    type() {
      if (this) {
        let type = this.$store.getters[`${this.deleteGuardNamespace}/getType`];
        if (type) {
          return type;
        }
      }
      return "genericDeleteModal";
    },
    show() {
      if (this) {
        return this.$store.getters[`${this.deleteGuardNamespace}/getShow`];
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  overflow: hidden;
}

.story-city-button {
  width: 192px;
}
</style>
